module.exports = {
  siteMetadata: {
    title: 'Phanor Coll - Fullstack Developer',
    author: `Phanor Coll`,
    description: `gopher in action`,
    homepage: `https://twitter.com/phanor`,
    siteUrl: `https://www.phanorcoll.com`,
    disqusShortname: `phanorcoll`,
    twitter: `@phanor`,
    facebookAppId: '237047893789050'
  },
  plugins: [
    'gatsby-plugin-react-helmet',
    `gatsby-plugin-sass`,
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        name: 'src',
        path: `${__dirname}/src`,
      },
    },
    {
      resolve: `gatsby-transformer-remark`,
      options: {
        plugins: [
          `gatsby-remark-prismjs`,
          {
            resolve: `gatsby-remark-images`,
            options: {
              maxWidth: 491,
            },
          },
          {
            resolve: `gatsby-remark-prismjs`,
            options: {
              // Class prefix for <pre> tags containing syntax highlighting;
              // defaults to 'language-' (eg <pre class="language-js">).
              // If your site loads Prism into the browser at runtime,
              // (eg for use with libraries like react-live),
              // you may use this to prevent Prism from re-processing syntax.
              // This is an uncommon use-case though;
              // If you're unsure, it's best to use the default value.
              classPrefix: 'language-',
              // This is used to allow setting a language for inline code
              // (i.e. single backticks) by creating a separator.
              // This separator is a string and will do no white-space
              // stripping.
              // A suggested value for English speakers is the non-ascii
              // character '›'.
              inlineCodeMarker: null,
              // This lets you set up language aliases.  For example,
              // setting this to '{ sh: "bash" }' will let you use
              // the language "sh" which will highlight using the
              // bash highlighter.
              aliases: {},
            },
          },
          {
            resolve: `gatsby-plugin-google-analytics`,
            options: {
              trackingId: 'UA-44807686-2',
              // Puts tracking script in the head instead of the body
              head: false,
              // Setting this parameter is optional
              anonymize: true,
              // Setting this parameter is also optional
              respectDNT: true,
              // Avoids sending pageview hits from custom paths
              exclude: ['/preview/**', '/do-not-track/me/too/'],
            },
          },
          {
            resolve: `gatsby-plugin-sitemap`,
            options: {
              output: `/sitemap.xml`,
              query: `
                {
                  site {
                    siteMetadata {
                      siteUrl
                    }
                  }
        
                  allSitePage {
                    edges {
                      node {
                        path
                      }
                    }
                  }
              }`,
            },
          },
          {
            resolve: 'gatsby-plugin-robots-txt',
            options: {
              host: 'https://www.phanorcoll.com',
              sitemap: 'https://www.phanorcoll.com/sitemap.xml',
              policy: [{ userAgent: '*', allow: '/' }],
            },
          },
          {
            resolve: 'gatsby-source-github',
            options: {
              headers: {
                Authorization: `Bearer f449982ad64375170b15d25503950d5fd5df9485`,
              },
              queries: [
                `{
                  user(login:"phanorcoll"){
                    url
                    repositories(last:9){
                      nodes{
                        name
                        url
                      }
                    }
                  }
                }`,
              ],
            },
          },
          {
            resolve: 'gatsby-plugin-robots-txt',
            options: {
              host: 'https://www.phanorcoll.com',
              sitemap: 'https://www.phanorcoll.com/sitemap.xml',
              policy: [{ userAgent: '*', allow: '/' }],
            },
          },
        ],
      },
    },
    {
      resolve: 'gatsby-plugin-mailchimp',
      options: {
        endpoint: 'https://facebook.us17.list-manage.com/subscribe/post?u=7fbd32ee79fd193071d3541ca&amp;id=a19c598da7',
      },
    },
    `gatsby-remark-copy-linked-files`,
    `gatsby-transformer-sharp`,
    `gatsby-plugin-sharp`,
  ],
}



// WEBPACK FOOTER //
// ./gatsby-config.js